import React, { useContext } from 'react';
import { FormInstance } from 'antd';

export interface AddressFormContext {
	accountAddressForm: FormInstance;
	billingAddressForm: FormInstance;
}

const AddressFormContext = React.createContext<AddressFormContext>(null!);

export const useAddressFormContext = () => {
	return useContext(AddressFormContext);
};

export const AddressFormContextProvider = AddressFormContext.Provider;
